/* eslint-disable indent */
import React, { Component } from "react";
import Button, { LoadingButton } from "@atlaskit/button";
import ContentWrapper from "../../../components/ContentWrapper";
import axios from "axios";
import Element from "../../../components/Element";
import { FormContext } from "../../FormContext";
import Form, { FormFooter } from "@atlaskit/form";
import Tabs, { Tab, TabList, TabPanel } from "@atlaskit/tabs";
import ErrorIcon from "@atlaskit/icon/glyph/error";
import Banner from "@atlaskit/banner";
import ProjectService from "../../../services/ProjectService";
import SqlCustomFieldService from "../../../services/SqlCustomFieldService";
import Spinner from "@atlaskit/spinner";
import AuthenticationService from "../../../services/AuthenticationService";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "@atlaskit/modal-dialog";
import TransitionsService from "../../../services/TransitionsService";
import IssueService from "../../../services/IssueService";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ConfigurationService from "../../../services/ConfigurationService";
import convertSize from "convert-size";
import maxFileSizeByList from "../../../helpers/max-file-size-ByList";

import "./UpdateIssue.css";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default class UpdateIssue extends Component {
  static contextType = FormContext;
  constructor(props) {
    super(props);
    this.state = {
      disableCreate: true,
      showSpin: false,
      loading: true,
      id: "",
      name: "",
      idProject: "",
      nameproject: "",
      fields: [],
      tabs: [],
      formelements: [],
      open: false,
      error: null,
      successful: false,
      message: null,
      isLoadingButton: false,
      openNotif: false,
      MaxFileSize: 0,
      MaxFileSizeString: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  async getFields() {
    const res1 = await axios.get(
      process.env.REACT_APP_API_URL + "/screen/form/" + 10500 + "/" + 10301
    );
    const data1 = res1.data;
    const screen = data1[0];

    var MaxFileSizeString = "";

    const res = await ConfigurationService.getConfig()
      .then((res) => {
        MaxFileSizeString = res.data.maxfilesize;
      })
      .catch((error) => {});

    MaxFileSizeString =
      MaxFileSizeString.slice(0, -2) + " " + MaxFileSizeString.slice(-2);

    const maxFileSize = convertSize(MaxFileSizeString);
    this.addHidentoFields(screen.tabs);
    screen.tabs.forEach((tab) => {
      tab.jiraFields
        .filter(
          (field) =>
            field.type === "Champ texte (mono-ligne)" ||
            field.type === "Text Field (single line)"
        )
        .forEach((field) => {
          field.allowedValues = this.props.issue.fields[field.id];
        });
    });

    this.setState({
      tabs: screen.tabs,
      disableCreate: false,
      showSpin: false,
      MaxFileSize: maxFileSize,
      MaxFileSizeString: MaxFileSizeString,
    });
    this.saveFields();
    this.sqlCustomFieldInitValueState();
    this.selectedValeuSql(
      screen.tabs,
      this.getFieldByName("Marque du véhicule").id
    );
    this.selectedValeuSql(
      screen.tabs,
      this.getFieldByName("Modèle du véhicule").id
    );
  }

  async sqlCustomFieldInitValueState() {
    const marque = this.getFieldByName("Marque du véhicule").id;

    const listMarques = await SqlCustomFieldService.getOptions(marque, []);
    this.setAllwedValues(marque, listMarques);

    const model = this.getFieldByName("Modèle du véhicule").id;

    const car = [
      {
        id: marque,
        value: this.props.issue.fields[marque],
      },
    ];
    const listmodels = await SqlCustomFieldService.getOptions(model, car);

    this.setAllwedValues(model, listmodels);
  }

  setAllwedValues = (id, values) => {
    const newTab = this.state.tabs;
    newTab.forEach((tab) =>
      tab.jiraFields
        .filter((field) => field.type === "SQL Customfield")
        .forEach((field) => {
          if (field.id === id) {
            field.allowedValues = values;
          }
        })
    );
    this.setState({ tabs: newTab });
  };

  addHidentoFields(tabs) {
    tabs.forEach((tab) => {
      tab.jiraFields.forEach((field) => {
        if (
          field.name === "Autre Modèle" ||
          field.name === "Autre Marque" ||
          field.name === "Type du véhicule"
        ) {
          field.hiden = true;
        } else {
          field.hiden = false;
        }
      });
    });
    tabs.forEach((tab) => {
      tab.jiraFields.forEach((field) => {
        if (field.type === "SQL Customfield") {
          field.valeur = null;
        }
      });
    });
  }

  selectedValeuSql(tabs, id) {
    tabs.forEach((tab) => {
      tab.jiraFields.forEach((field) => {
        if (field.id === id) {
          field.valeur = {
            label: this.props.issue.fields[field.id],
            valeu: this.props.issue.fields[field.id],
          };
        }
      });
    });
  }

  getvalue(idField) {
    const field = this.state.formelements.filter((f) => f.id === idField);
    return field[0].value;
  }

  getFieldByName = (name) => {
    var newField = null;
    this.state.tabs.forEach((tab) => {
      tab.jiraFields.forEach((field) => {
        if (field.name === name) return (newField = field);
      });
    });
    return newField;
  };

  showMarqueAndAutre() {
    const vlMarque = this.getvalue(
      this.getFieldByName("Marque du véhicule").id
    );
    const vlModele = this.getvalue(
      this.getFieldByName("Modèle du véhicule").id
    );
    const newtabs = this.state.tabs;

    if (vlMarque === "Autre") {
      newtabs.forEach((tab) => {
        tab.jiraFields.forEach((field) => {
          if (
            field.name === "Autre Modèle" ||
            field.name === "Autre Marque" ||
            field.name === "Type du véhicule"
          ) {
            field.hiden = false;
          }
        });
      });
    } else {
      if (vlMarque !== "Autre" && vlModele === "Autre") {
        newtabs.forEach((tab) => {
          tab.jiraFields.forEach((field) => {
            if (field.name === "Autre Modèle") {
              field.hiden = false;
            }
            if (field.name === "Autre Marque") {
              field.hiden = true;
            }
            if (field.name === "Type du véhicule") {
              field.hiden = false;
            }
          });
        });
      } else {
        newtabs.forEach((tab) => {
          tab.jiraFields.forEach((field) => {
            if (
              field.name === "Autre Modèle" ||
              field.name === "Autre Marque" ||
              field.name === "Type du véhicule"
            ) {
              field.hiden = true;
            }
          });
        });
      }
    }
    this.setState({ tabs: newtabs });
  }

  async initValeu(tabs) {
    tabs.forEach((tab) => {
      tab.jiraFields.forEach((field) => {
        // if element is sqlCustomField
        if (field.type === "SQL Customfield") {
          //  get typologie
          const typo = this.gettypo(field.id);
          if (typo.type === "SELECT") {
            const df = SqlCustomFieldService.getDF(field.id).then(
              (response) => {
                return response.data;
              }
            );
            const value = SqlCustomFieldService.getOptions(field.id, df);
          }
        }
      });
    });
  }

  async gettypo(fieldid) {
    const typo = await SqlCustomFieldService.getSqlFieldsTypologie(fieldid);
    return typo;
  }

  UNSAFE_componentWillMount() {
    this.getFields();
  }

  getModel = async (car) => {
    const listModels = await SqlCustomFieldService.getOptions(
      this.getFieldByName("Modèle du véhicule").id,
      car
    );

    return listModels;
  };

  handleChange = async (id, event, val) => {
    const newElements = [...this.state.formelements];

    if (id === this.getFieldByName("Marque du véhicule").id) {
      const car = [
        {
          id: this.getFieldByName("Marque du véhicule").id,
          value: event.value,
        },
      ];
      const models = await this.getModel(car);
      const newTab = this.state.tabs;
      newTab.forEach((tab) =>
        tab.jiraFields
          .filter((field) => field.type === "SQL Customfield")
          .forEach((field) => {
            if (field.id === this.getFieldByName("Modèle du véhicule").id) {
              field.allowedValues = models;
            }
          })
      );
      this.setState({ tabs: newTab });

      this.setSelectedSqlValeu(
        this.getFieldByName("Modèle du véhicule").id,
        null
      );
    }

    newElements.forEach((field) => {
      if (id === field.id) {
        switch (field.type) {
          // eslint-disable-next-line
          case "checkbox":
            field["field_value"] = event.target.checked;
            break;
          case "SQL Customfield":
            if (event) {
              field["value"] = event.value;
            } else {
              field["value"] = val;
            }
            break;
          case "Champ de système":
          case "System field":
            if (id === "attachment") {
              field["value"] = val;
            } else {
              field["value"] = event.value;
            }
            break;
          case "Liste de choix (à choix unique)":
          case "Select List (single choice)":
            field["value"] = { value: event.label };
            break;
          case "Liste de choix (à choix multiples)":
            field["value"] = { value: val };
            break;

          case "Sélecteur de date":
          case "Date Picker":
            field["value"] = event;
            break;
          case "Sélectionneur d'utilisateur (utilisateur unique)":
          case "User Picker (single user)":
            field["value"] = { name: val };
            break;

          case "Cases à cocher":
          case "Checkboxes":
            field["value"] = [{ value: event.target.name }];
            break;
          default:
            field["value"] = event.target.value;
            this.changeAllowedValeu(field.id, event.target.value);
            break;
        }
      }
    });

    this.setState({ formelements: newElements });
    this.showMarqueAndAutre();
  };

  changeAllowedValeu = (fieldId, value) => {
    const newTabs = this.state.tabs;
    newTabs.forEach((tab) => {
      tab.jiraFields
        .filter((field) => field.id === fieldId)
        .forEach((field) => {
          field.allowedValues = value;
        });
    });

    this.setState({ tabs: newTabs });
  };

  updateTabsState = (childs) => {
    let newTabs = this.state.tabs;
    let newFormElement = this.state.formelements;
    childs.forEach((child) => {
      newTabs.forEach((tab) => {
        tab.jiraFields.forEach((field) => {
          let childId = "customfield_" + child.id;
          if (
            childId === field.id &&
            field.type !== "Liste de choix (à choix unique)"
          ) {
            field.allowedValues = child.value;
            newFormElement.forEach((el) => {
              if (el.id === field.id) {
                el.value = field.allowedValues;
              }
            });
            console.log(field.allowedValues);
          }
        });
      });
    });
    this.setState({ tabs: newTabs, formelements: newFormElement });
  };

  tabs() {
    const form = (
      <Tabs onChange={(index) => console.log("Selected Tab", index + 1)}>
        <TabList>
          {this.state.tabs.length <= 1 ? (
            <Tab></Tab>
          ) : (
            this.state.tabs.map((tab) => {
              return <Tab>{tab.name}</Tab>;
            })
          )}
        </TabList>

        {this.state.tabs.map((tab) => {
          return (
            <TabPanel key={tab.id}>
              <div className="aui-page-panel-content">
                {tab.jiraFields.map((field) => {
                  return (
                    <div className="field-group">
                      <Element key={field.id} field={field} />
                    </div>
                  );
                })}
              </div>
            </TabPanel>
          );
        })}
      </Tabs>
    );

    return form;
  }

  saveFields() {
    const elements = [];
    this.state.tabs.forEach((tab) => {
      tab.jiraFields.forEach((field) => {
        const el = { id: field.id, value: "", type: field.type };
        elements.push(el);
      });
    });
    this.setState({ formelements: elements, loading: false }, () => {
      console.log(this.state);
    });
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState(
      { open: false, error: null, isLoadingButton: true },
      () => {}
    );

    let fields = {};

    this.state.formelements
      .filter((field) => field.id !== "attachment" && field.value !== "")
      .forEach((field) => {
        fields = { ...fields, [field.id]: field.value };
      });

    const file = this.state.formelements.filter(
      (field) => field.id === "attachment"
    );
    const data = { fields: fields };

    let formData = new FormData();

    if (file[0].value.length !== 0 || file[0].value !== "") {
      if (maxFileSizeByList(file, this.state.MaxFileSize)) {
        const errors =
          "La taille maximale du fichier est de " +
          this.state.MaxFileSizeString;

        const error = { errors: errors };

        this.setState({
          open: true,
          error: error,
          isLoadingButton: false,
        });
        return false;
      } else {
        file[0].value.map((fileElement) =>
          formData.append("file", fileElement)
        );
      }
    }
    console.log(fields);

    await TransitionsService.assignee(this.props.issue.id, "Admin")
      .then((res) => {
        console.log(res.data);
        console.log("toadmin");
      })
      .catch((error) => {
        console.log(error.response.data);
      });

    await TransitionsService.executeUpdateTrannstion(
      this.props.issue.id,
      fields
    )
      .then((res) => {
        this.setState({ openNotif: true });
      })
      .catch((err) => {
        console.log(err.response);
        this.setState({ error: err.response.data, open: true });
        return false;
      });

    if (file[0].value !== "") {
      await IssueService.saveAttachment(this.props.issue.id, formData)
        .then((response) => {
          console.log(response.date);
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    }

    await TransitionsService.assignee(
      this.props.issue.id,
      AuthenticationService.getCurrentUser().username
    )
      .then((res) => {})
      .catch((error) => {
        console.log(error.response.data);
      });
    if (!this.state.error) {
      this.refreshPage();
    }
  };

  refreshPage = () => {
    window.location.reload();
  };

  showerror = () => {
    if (Array.isArray(this.state.error.errorMessages)) {
      return (
        <div className="error-panel">
          <Banner
            appearance="error"
            icon={<ErrorIcon label="" secondaryColor="inherit" />}
            isOpen
          >
            {this.state.error.errorMessages[0]}
          </Banner>
        </div>
      );
    } else {
      if (this.state.error.errors) {
        return (
          <div className="error-panel">
            <Banner
              appearance="error"
              icon={<ErrorIcon label="" secondaryColor="inherit" />}
              isOpen
            >
              {this.state.error.errors}
            </Banner>
          </div>
        );
      } else {
        return (
          <div className="error-panel">
            <Banner
              appearance="error"
              icon={<ErrorIcon label="" secondaryColor="inherit" />}
              isOpen
            >
              {this.state.error}
            </Banner>
          </div>
        );
      }
    }
  };

  showSuccessful = () => {
    return (
      <Banner appearance="announcement" isOpen>
        <p>save issue with id </p>
        {this.state.message.id}
        <p> and key </p>
        {this.state.message.key}
      </Banner>
    );
  };

  async sqlCustomFieldInitValue(tabs) {
    tabs.forEach((tab) =>
      tab.jiraFields
        .filter((field) => field.type === "SQL Customfield")
        .forEach((field) => {
          const res = SqlCustomFieldService.getSqlFieldsTypologie(field.id);
          res
            .then((val) => {
              const typo = val.data.type;
              if (typo === "SELECT") {
                const depandFields = SqlCustomFieldService.getDF(field.id).then(
                  (dfs) => {
                    return dfs.map((df) => {
                      df.value = this.getCustomFieldValue(df.id);
                      return df;
                    });
                  }
                );
                const options = depandFields.then((val) => {
                  return SqlCustomFieldService.getOptions(field.id, val);
                });

                options.then((val) => {
                  field.allowedValues = val;
                });
              }
            })
            .catch((err) => console.log("error"));
        })
    );

    return tabs;
  }

  getCustomFieldValue(idField) {
    const field = this.state.formelements.filter((elem) => elem.id === idField);
  }
  loading = () => (
    <div style={{ flexWrap: "wrap", alignContent: "center" }}>
      <div
        style={{
          display: "flex",
          flexDrection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner size="large" />
      </div>
    </div>
  );

  redirectToShowISsue(id) {
    this.props.history.push("issue/" + id);
  }
  handleCloseNotif = () => {
    this.setState({ openNotif: false });
  };

  setSelectedSqlValeu = (id, values) => {
    const newTab = this.state.tabs;
    newTab.forEach((tab) =>
      tab.jiraFields
        .filter((field) => field.type === "SQL Customfield")
        .forEach((field) => {
          if (field.id === id) {
            field.valeur = values;
          }
        })
    );
    this.setState({ tabs: newTab });
  };

  render() {
    return (
      <div className="updateIssueModalContainer">
        {this.props.openModel && (
          <Modal width="large" className="updateIssueModal">
            <ModalTitle>
              <div className="updateIssueModalHeader">Modifier</div>
            </ModalTitle>
            <ModalBody className="updateIssueModalBody">
              <div>
                <ContentWrapper>
                  {this.state.open ? this.showerror() : null}
                  {this.state.successful ? this.showSuccessful() : null}
                  <FormContext.Provider
                    value={{
                      handleChange: this.handleChange,
                      updateTabs: this.updateTabsState,
                      issue: this.props.issue,
                      setSelectedSqlValeu: this.setSelectedSqlValeu,
                    }}
                  >
                    {this.state.showSpin && this.loading()}
                    <Form onSubmit={(data) => console.log(data)}>
                      {({ formProps }) => (
                        <form {...formProps}>
                          {!this.state.loading ? this.tabs() : <p></p>}
                        </form>
                      )}
                    </Form>
                  </FormContext.Provider>
                </ContentWrapper>
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="buttonsContainer">
                <Button
                  type="submit"
                  appearance="link"
                  onClick={this.props.toggleModal}
                  style={{ float: "right" }}
                >
                  Annuler
                </Button>
                <LoadingButton
                  type="submit"
                  isLoading={this.state.isLoadingButton}
                  className="aui-button"
                  isDisabled={this.state.disableCreate}
                  onClick={(e) => this.handleSubmit(e)}
                  style={{ float: "right" }}
                >
                  Modifier
                </LoadingButton>
              </div>
            </ModalFooter>
          </Modal>
        )}
        <Snackbar
          open={this.state.openNotif}
          autoHideDuration={6000}
          onClose={this.handleCloseNotif}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Alert
            severity="info"
            action={
              <React.Fragment>
                <IconButton
                  aria-label="close"
                  color="inherit"
                  sx={{ p: 0.5 }}
                  onClick={this.handleCloseNotif}
                >
                  <CloseIcon />
                </IconButton>
              </React.Fragment>
            }
          >
            This is an information message!
          </Alert>
        </Snackbar>
      </div>
    );
  }
}
